import { useContext } from "react";
import { _ROUTER_DOM_URL } from "../utils/_routes_constants";
import { UserContext } from "../contexts/UserContext";

const AppRights = ({ roles }) => {
  const { user } = useContext(UserContext);

  /**
   * Checks if the user has the required roles to access a resource.
   * If the user does not have the required roles, they are redirected to the "Not Allowed" page.
   *
   * @function CheckRights
   */
  const CheckRights = () => {
    if (!user.roles.some((value) => roles.includes(value))) {
      window.location.href = _ROUTER_DOM_URL.NOT_ALLOWED;
    }
  };

  CheckRights();

  return <></>;
};

export default AppRights;
